"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2090],{

/***/ 90400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37989);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70754);




function ModalButton(props) {
    var handleNext = props.handleNext, text = props.text, form = props.form, type = props.type, alternative = props.alternative, alternativeText = props.alternativeText, disabled = props.disabled, children = props.children, loading = props.loading;
    var handleClick = function(event) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        handleNext();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .ButtonDiv */ .Lw, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                    onClick: handleClick,
                    form: form,
                    type: type,
                    alternative: Boolean(alternative),
                    disabled: disabled,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .TypographyButton */ .yU, {
                            children: alternative ? alternativeText : text
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20,
                            color: "inherit"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ usePendingPrescriptions; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/queries/order/queries/currentOrderWithPrescriptions.ts
var currentOrderWithPrescriptions = __webpack_require__(3073);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/prescription/queries/lookForPrescriptions.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LookForPrescription {\n    lookForPrescriptions {\n      prescriptionRequired\n      associations {\n        orderDetail {\n          id\n          product {\n            id\n            prescriptionType\n          }\n          quantity\n        }\n        prescriptionId\n        prescription {\n          id\n          url\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lookForPrescriptions = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
;// CONCATENATED MODULE: ./src/hooks/usePendingPrescriptions.ts





function usePendingPrescriptions() {
    var ref, ref1, ref2;
    var appUser = (0,useAuth/* useAuth */.a)().appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var ref3 = (0,useQuery/* useQuery */.a)((0,currentOrderWithPrescriptions/* currentOrderWithPrescriptions */.l)(), {
        returnPartialData: true,
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), prescriptionsData = ref3.data, prescriptionsLoading = ref3.loading;
    var productsWithPrescription = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : (ref = prescriptionsData.currentOrder) === null || ref === void 0 ? void 0 : ref.orderDetails.filter(function(detail) {
        return detail.product.prescriptionType;
    }).map(function(detail) {
        return detail.product;
    });
    var ref4 = (0,useQuery/* useQuery */.a)(lookForPrescriptions(), {
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), lookForPrescriptionsData = ref4.data, prescriptionRequiredLoading = ref4.loading;
    if (isLocalVendor || isAssistantUser) return {
        requirePrescriptions: false,
        enoughAssociationsFound: true,
        requirePrescriptionUpload: false,
        loading: false,
        pendingPrescriptions: [],
        associatedPrescriptions: []
    };
    var ref5;
    var requirePrescriptions = (ref5 = productsWithPrescription === null || productsWithPrescription === void 0 ? void 0 : productsWithPrescription.length) !== null && ref5 !== void 0 ? ref5 : 0;
    var requirePrescriptionUpload = productsWithPrescription === null || productsWithPrescription === void 0 ? void 0 : productsWithPrescription.some(function(product) {
        return product.prescriptionType !== "NOT_REQUIRED";
    });
    var ref6;
    var associationsAmount = (ref6 = lookForPrescriptionsData === null || lookForPrescriptionsData === void 0 ? void 0 : (ref1 = lookForPrescriptionsData.lookForPrescriptions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.associations) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref6 !== void 0 ? ref6 : 0;
    var enoughAssociationsFound = associationsAmount == requirePrescriptions;
    var ref7;
    return {
        requirePrescriptions: requirePrescriptions,
        enoughAssociationsFound: enoughAssociationsFound,
        requirePrescriptionUpload: requirePrescriptionUpload,
        loading: prescriptionsLoading || prescriptionRequiredLoading,
        pendingPrescriptions: prescriptionsData === null || prescriptionsData === void 0 ? void 0 : prescriptionsData.pendingPrescriptions,
        associatedPrescriptions: (ref7 = lookForPrescriptionsData === null || lookForPrescriptionsData === void 0 ? void 0 : lookForPrescriptionsData.lookForPrescriptions.associations.map(function(association) {
            return association.prescription;
        })) !== null && ref7 !== void 0 ? ref7 : []
    };
}


/***/ }),

/***/ 3073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ currentOrderWithPrescriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query currentOrderWithPrescriptions($params: CurrentOrderParams) {\n    currentOrder(params: $params) {\n      id\n      orderDetails {\n        id\n        quantity\n        price\n        product {\n          id\n          name\n          imagesUrl\n          unit\n          format\n          concentration\n          laboratory\n          prescriptionType\n          availability {\n            stock\n            statusWithoutStock\n            status\n          }\n        }\n        status\n        prescription {\n          id\n        }\n      }\n    }\n    pendingPrescriptions {\n      id\n      uuid\n      url\n    }\n    currentUserInfo {\n      id\n      createdAt\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var currentOrderWithPrescriptions = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 52090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CheckoutPaymentMethodV2": function() { return /* binding */ CheckoutPaymentMethodV2; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/components/ModalHeader.tsx
var ModalHeader = __webpack_require__(69051);
// EXTERNAL MODULE: ./src/components/ModalContent.tsx + 1 modules
var ModalContent = __webpack_require__(84726);
// EXTERNAL MODULE: ./src/components/ModalButton.tsx
var ModalButton = __webpack_require__(90400);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/index.tsx + 17 modules
var components = __webpack_require__(69221);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PaymentFooter.tsx
var PaymentFooter = __webpack_require__(54955);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/InsuranceInfoDiv.styles.ts



var InfoDiv = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "hidden";
    }
})(function(param) {
    var hidden = param.hidden, theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        height: hidden ? "0px" : "40px",
        padding: hidden ? "0px 5px 0px 22px" : "5px 5px 5px 22px",
        marginTop: hidden ? "0px" : "12px",
        backgroundColor: "#E6F3FA",
        transition: "all 0.3s ease-in-out"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(470), {
        height: hidden ? "0px" : "60px"
    }), (0,_define_property/* default */.Z)(_obj, "& *", {
        opacity: hidden ? 0 : 1,
        transition: "opacity 0.3s ease-in-out"
    }), _obj;
});
var InfoIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)({
    padding: "0",
    marginRight: "17px",
    color: "#414046"
});
var InfoTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15.6px",
    letterSpacing: "0.15px",
    color: "#414046",
    span: {
        fontWeight: 500
    }
});


// EXTERNAL MODULE: ./src/queries/checkout/queries/paymentMethod.ts
var paymentMethod = __webpack_require__(66003);
// EXTERNAL MODULE: ./src/queries/userInsurance/queries/getUserInsurances.ts
var getUserInsurances = __webpack_require__(20641);
// EXTERNAL MODULE: ./src/queries/userInsurance/queries/getInsuranceQuote.ts
var getInsuranceQuote = __webpack_require__(90534);
// EXTERNAL MODULE: ./src/queries/checkout/queries/detail.ts
var detail = __webpack_require__(45482);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/PaymentSwitchContainer.ts

var PaymentSwitchContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "10px"
});


// EXTERNAL MODULE: ./src/queries/checkout/mutations/assignPaymentMethod.tsx
var assignPaymentMethod = __webpack_require__(50952);
// EXTERNAL MODULE: ./src/queries/order/mutations/setCheckoutOrderData.tsx
var setCheckoutOrderData = __webpack_require__(43013);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/utils.ts
function calculateHeight(format, showNextButton, userHasInsurances) {
    var baseHeight = format === "mobile" ? "100vh" : "90dvh";
    var height = "calc(".concat(baseHeight, " - 64px - 51px )"); // - 'Total a pagar' height
    if (showNextButton) return "calc(".concat(height, " - 80px)"); // - footer next button height
    if (!userHasInsurances) "calc(".concat(height, " - 42px)"); // - insurance message height
    return height;
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/paymentMethodStore.tsx
var paymentMethodStore = __webpack_require__(69355);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/localPaymentOptionsStore.tsx
var localPaymentOptionsStore = __webpack_require__(57500);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/assistantPaymentOptionsStore.tsx
var assistantPaymentOptionsStore = __webpack_require__(82031);
// EXTERNAL MODULE: ./src/components/Loader.tsx
var Loader = __webpack_require__(76931);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(98449);
// EXTERNAL MODULE: ./src/hooks/usePendingPrescriptions.ts + 1 modules
var usePendingPrescriptions = __webpack_require__(3618);
// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var useModalRouter = __webpack_require__(9006);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./node_modules/react-device-detect/main.js
var main = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/index.tsx




































function CheckoutPaymentMethodV2() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,useAuth/* useAuth */.a)(), user = ref6.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var modalRouter = (0,useModalRouter/* useModalRouter */.r)();
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref7 = (0,useOrderState/* useOrderState */.h)(), refetchOrder = ref7.refetch, orderUuid = ref7.orderUuid, orderStatus = ref7.orderStatus, currentOrder = ref7.order;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var ref8 = (0,react.useState)(0), payAmount = ref8[0], setPayAmount = ref8[1];
    // Zustand
    var ref9 = (0,paymentMethodStore/* usePaymentSelectors */.M6)(), mekiCreditsChecked = ref9.mekiCreditsChecked, totalReimbursement = ref9.totalReimbursement, totalDeductible = ref9.totalDeductible;
    var ref10 = (0,useMekiState/* useMekiState */.c)(), insuranceId = ref10.insuranceId, setInsuranceId = ref10.setInsuranceId, setInsuranceRut = ref10.setInsuranceRut;
    var ref11 = (0,paymentMethodStore/* usePaymentMethodActions */.pu)(), setOrders = ref11.setOrders, setOrdersTotal = ref11.setOrdersTotal, setPaymentMethods = ref11.setPaymentMethods, setInsuranceTotalInfo = ref11.setInsuranceTotalInfo, setMekiCreditsChecked = ref11.setMekiCreditsChecked;
    var ref12 = (0,assistantPaymentOptionsStore/* useAssistantPaymentOptions */.S)(), sendEmail = ref12.sendEmail, chargeDeliveryCost = ref12.chargeDeliveryCost;
    var setChargeDeliveryCost = (0,assistantPaymentOptionsStore/* useAssistantPaymentActions */.M)().setChargeDeliveryCost;
    var paymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOption */.Z)().paymentOption;
    var ref13 = (0,react.useState)(false), redirecting = ref13[0], setRedirecting = ref13[1];
    var ref14 = (0,react.useState)(false), quoteLoading = ref14[0], setQuoteLoading = ref14[1];
    // Queries
    var ref15 = (0,useQuery/* useQuery */.a)((0,paymentMethod/* getCheckoutPaymentMethod */.k)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        },
        fetchPolicy: "cache-first"
    }), orderAndUserInfoData = ref15.data, loadingMethod = ref15.loading;
    var ref16 = (0,useQuery/* useQuery */.a)((0,detail/* OrderDeliveryOptions */.J)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        },
        fetchPolicy: "cache-and-network"
    }), tmp = ref16.data, orderDeliveryOptions = (tmp === void 0 ? {} : tmp).orderDeliveryOptions, loadingDeliveryOptions = ref16.loading;
    var ref17 = orderAndUserInfoData !== null && orderAndUserInfoData !== void 0 ? orderAndUserInfoData : {}, currentUserInfo = ref17.currentUserInfo, paymentMethods = ref17.paymentMethods;
    var ref18 = (0,useQuery/* useQuery */.a)((0,getUserInsurances/* getUserInsurances */.D)(), {
        fetchPolicy: "no-cache",
        variables: {
            params: {
                userId: user === null || user === void 0 ? void 0 : user.id
            }
        }
    }), insurancesData = ref18.data, loadingInsurances = ref18.loading;
    var requirePrescriptions = (0,usePendingPrescriptions/* usePendingPrescriptions */.h)().requirePrescriptions;
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,setCheckoutOrderData/* setCheckoutOrderData */.r)()), 1), setCheckoutData = ref19[0];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,getInsuranceQuote/* getInsuranceQuote */.H)(), {
        fetchPolicy: "no-cache"
    }), 2), getInsuranceQuoteLazy = ref20[0], ref21 = ref20[1], quoteData = ref21.data, loadingGetInsuranceQuote = ref21.loading, insuranceQuoteError = ref21.error;
    var loadInsuranceQuote = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(rut) {
            var quoteDataResponse, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (orderStatus != "DRAFT") {
                            utils/* Console.log */.Mn.log("loadInsuranceQuote not ran. Order status is not DRAFT");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setQuoteLoading(true);
                        return [
                            4,
                            getInsuranceQuoteLazy({
                                variables: {
                                    params: {
                                        rut: rut
                                    }
                                }
                            })
                        ];
                    case 2:
                        quoteDataResponse = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        utils/* Console.log */.Mn.log("Loading insurance quote failed", error);
                        throw error;
                    case 4:
                        setQuoteLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(rut) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getInsuranceQuoteLazy,
        orderStatus
    ]);
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, mostRecentInsurance, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((insurancesData === null || insurancesData === void 0 ? void 0 : (ref = insurancesData.getUserInsurances) === null || ref === void 0 ? void 0 : ref.length) !== 0)) return [
                                3,
                                4
                            ];
                            mostRecentInsurance = insurancesData === null || insurancesData === void 0 ? void 0 : (ref1 = insurancesData.getUserInsurances) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(latest, current) {
                                return new Date(current.usedAt) > new Date(latest.usedAt) ? current : latest;
                            });
                            if (!mostRecentInsurance) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            setInsuranceId(mostRecentInsurance.id);
                            setInsuranceRut(mostRecentInsurance.rut);
                            return [
                                4,
                                loadInsuranceQuote(mostRecentInsurance === null || mostRecentInsurance === void 0 ? void 0 : mostRecentInsurance.rut)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            setInsuranceId(null);
                            setInsuranceRut(null);
                            utils/* Console.log */.Mn.log("Loading insurance quote failed", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        void fetchData();
    }, [
        insurancesData === null || insurancesData === void 0 ? void 0 : insurancesData.getUserInsurances,
        setInsuranceId,
        setInsuranceRut,
        loadInsuranceQuote, 
    ]);
    var userHasInsurances = (0,react.useMemo)(function() {
        var ref;
        return Boolean(user === null || user === void 0 ? void 0 : user.hasUserInsurance) && (insurancesData === null || insurancesData === void 0 ? void 0 : (ref = insurancesData.getUserInsurances) === null || ref === void 0 ? void 0 : ref.length) > 0;
    }, [
        user === null || user === void 0 ? void 0 : user.hasUserInsurance,
        insurancesData === null || insurancesData === void 0 ? void 0 : (ref = insurancesData.getUserInsurances) === null || ref === void 0 ? void 0 : ref.length
    ]);
    var orders = (ref1 = orderDeliveryOptions === null || orderDeliveryOptions === void 0 ? void 0 : orderDeliveryOptions.find(function(item) {
        return item.dates.length === ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderGroupId) ? 2 : 1);
    })) === null || ref1 === void 0 ? void 0 : ref1.orders;
    var orderDetailsAmount = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
        return acc + order.orderDetails.length;
    }, 0);
    var ordersTotal = (0,react.useMemo)(function() {
        var ref;
        return (ref = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
            var orderTotal = order.orderDetails.reduce(function(acc, detail) {
                return acc + detail.quantity * detail.price;
            }, 0);
            if (!chargeDeliveryCost && isAssistantUser) {
                return acc + orderTotal;
            }
            return acc + orderTotal + (chargeDeliveryCost ? order.deliveryCost : 0);
        }, 0)) !== null && ref !== void 0 ? ref : 0;
    }, [
        chargeDeliveryCost,
        isAssistantUser,
        orders
    ]);
    var contentLoading = loadingDeliveryOptions || loadingMethod || !orderDeliveryOptions;
    var showInsuranceOptions = !mekiCreditsChecked || (currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) == 0;
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,assignPaymentMethod/* assignPaymentMethod */.n)()), 1), assignMethod = ref22[0];
    (0,react.useEffect)(function() {
        if ((currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) === 0 || userHasInsurances) {
            setMekiCreditsChecked(false);
        }
    }, [
        currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits,
        setMekiCreditsChecked,
        userHasInsurances
    ]);
    var reimbursedProductIds = quoteData === null || quoteData === void 0 ? void 0 : (ref2 = quoteData.getInsuranceQuote) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reimbursedProducts) === null || ref3 === void 0 ? void 0 : ref3.map(function(product) {
        return +product.sku;
    });
    var ref23;
    var productsWithInsurance = (ref23 = reimbursedProductIds === null || reimbursedProductIds === void 0 ? void 0 : reimbursedProductIds.length) !== null && ref23 !== void 0 ? ref23 : 0;
    (0,react.useEffect)(function() {
        var finalReimbursement = (totalReimbursement !== null && totalReimbursement !== void 0 ? totalReimbursement : 0) - (totalDeductible !== null && totalDeductible !== void 0 ? totalDeductible : 0);
        var ordersTotalFinal = mekiCreditsChecked ? Math.max(ordersTotal - (currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits), 0) : insuranceId ? ordersTotal - finalReimbursement : ordersTotal;
        setPayAmount(ordersTotalFinal);
    }, [
        mekiCreditsChecked,
        ordersTotal,
        quoteData,
        currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits,
        currentUserInfo,
        totalReimbursement,
        insuranceId,
        totalDeductible, 
    ]);
    var showNextButton = mekiCreditsChecked && payAmount == 0 || isAssistantUser && paymentOption == "TRANSFER" || !mekiCreditsChecked && payAmount == 0;
    var assignOrderMetadata = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, claimId, userInsuranceId, totalReimbursement, totalDeductible, totalCopay, reimbursedProducts, cleanReimbursedProducts, ref4, ref5;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref3 = (ref2 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.getInsuranceQuote) !== null && ref2 !== void 0 ? ref2 : {}, claimId = ref3.claimId, userInsuranceId = ref3.insuranceId, totalReimbursement = ref3.totalReimbursement, totalDeductible = ref3.totalDeductible, totalCopay = ref3.totalCopay, reimbursedProducts = ref3.reimbursedProducts;
                    cleanReimbursedProducts = reimbursedProducts === null || reimbursedProducts === void 0 ? void 0 : reimbursedProducts.map(function(product) {
                        if (product.coverage) {
                            return {
                                sku: +product.sku,
                                observation: product.observation,
                                unitReimbursement: product.unitReimbursement,
                                unitDeductible: product.unitDeductible,
                                unitCopay: product.unitCopay,
                                quantity: product.quantity,
                                coverage: product.coverage
                            };
                        }
                    });
                    return [
                        4,
                        setCheckoutData({
                            variables: {
                                params: {
                                    orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                    replace: false,
                                    metadata: {
                                        useMekiCredits: mekiCreditsChecked !== null && mekiCreditsChecked !== void 0 ? mekiCreditsChecked : false,
                                        chargeDeliveryCost: chargeDeliveryCost !== null && chargeDeliveryCost !== void 0 ? chargeDeliveryCost : true,
                                        insuranceInfo: !insuranceId ? null : {
                                            claimId: (ref4 = +claimId) !== null && ref4 !== void 0 ? ref4 : null,
                                            rut: (ref5 = quoteData === null || quoteData === void 0 ? void 0 : (ref = quoteData.getInsuranceQuote) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.rut) !== null && ref5 !== void 0 ? ref5 : "",
                                            insuranceId: userInsuranceId !== null && userInsuranceId !== void 0 ? userInsuranceId : null,
                                            totalReimbursement: totalReimbursement !== null && totalReimbursement !== void 0 ? totalReimbursement : 0,
                                            totalDeductible: totalDeductible !== null && totalDeductible !== void 0 ? totalDeductible : 0,
                                            totalCopay: totalCopay !== null && totalCopay !== void 0 ? totalCopay : 0,
                                            reimbursedProducts: cleanReimbursedProducts !== null && cleanReimbursedProducts !== void 0 ? cleanReimbursedProducts : []
                                        },
                                        localVendor: null,
                                        assistantVendor: isAssistantUser ? {
                                            paymentMethod: paymentOption
                                        } : null,
                                        sendEmail: sendEmail !== null && sendEmail !== void 0 ? sendEmail : true,
                                        userInfo: null,
                                        installments: 0
                                    }
                                }
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        refetchOrder()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        quoteData === null || quoteData === void 0 ? void 0 : quoteData.getInsuranceQuote,
        setCheckoutData,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        mekiCreditsChecked,
        chargeDeliveryCost,
        insuranceId,
        isAssistantUser,
        paymentOption,
        sendEmail,
        refetchOrder, 
    ]);
    var handleNext = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(intallmentsRedirect) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setRedirecting(true);
                        return [
                            4,
                            assignOrderMetadata()
                        ];
                    case 1:
                        _state.sent();
                        if (intallmentsRedirect && payAmount > 0) {
                            void modalRouter.push((0,utils/* getRoute */.Bv)("checkoutInstallments"));
                            return [
                                2
                            ];
                        }
                        if (requirePrescriptions) {
                            void modalRouter.push((0,utils/* getRoute */.Bv)("checkoutPrescriptions"));
                            return [
                                2
                            ];
                        }
                        void modalRouter.push((0,utils/* getRoute */.Bv)("checkoutPaymentConfirm"));
                        return [
                            2
                        ];
                }
            });
        });
        return function(intallmentsRedirect) {
            return _ref.apply(this, arguments);
        };
    }(), [
        assignOrderMetadata,
        modalRouter,
        payAmount,
        requirePrescriptions
    ]);
    (0,react.useEffect)(function savePaymentMethodsValue() {
        setPaymentMethods(paymentMethods);
    }, [
        paymentMethods,
        setPaymentMethods
    ]);
    (0,react.useEffect)(function setZustandInitialValues() {
        setChargeDeliveryCost(isLocalVendor || (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryCost) == 0 ? false : true);
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.deliveryCost,
        isLocalVendor,
        setChargeDeliveryCost
    ]);
    (0,react.useEffect)(function refreshOrderTotalPayAmount() {
        setOrders(orders);
        setOrdersTotal(ordersTotal);
    }, [
        orders,
        ordersTotal,
        setOrders,
        setOrdersTotal
    ]);
    (0,react.useEffect)(function refreshTotalReimbursement() {
        var ref, ref1;
        var ref2, ref3;
        setInsuranceTotalInfo({
            totalReimbursement: (ref2 = quoteData === null || quoteData === void 0 ? void 0 : (ref = quoteData.getInsuranceQuote) === null || ref === void 0 ? void 0 : ref.totalReimbursement) !== null && ref2 !== void 0 ? ref2 : 0,
            totalDeductible: (ref3 = quoteData === null || quoteData === void 0 ? void 0 : (ref1 = quoteData.getInsuranceQuote) === null || ref1 === void 0 ? void 0 : ref1.totalDeductible) !== null && ref3 !== void 0 ? ref3 : 0
        });
    }, [
        quoteData === null || quoteData === void 0 ? void 0 : quoteData.getInsuranceQuote,
        setInsuranceTotalInfo
    ]);
    (0,react.useEffect)(function() {
        if (!mekiCreditsChecked && payAmount === 0 && !contentLoading) {
            var assingMekiCreditPaymentMethod = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    assignMethod({
                                        variables: {
                                            params: {
                                                orderUuid: orderUuid,
                                                paymentMethodUuid: "00000000-0000-0000-0000-00000006"
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                assignPaymentMethod: {
                                                    __typename: "Order",
                                                    id: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                                    uuid: orderUuid,
                                                    paymentMethod: {
                                                        id: -7
                                                    }
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function assingMekiCreditPaymentMethod() {
                    return _ref.apply(this, arguments);
                };
            }();
            void assingMekiCreditPaymentMethod();
            void track("add payment succeed", {
                payment_method_type: "INSURANCE",
                userId: user === null || user === void 0 ? void 0 : user.id
            });
        }
        if (mekiCreditsChecked && payAmount === 0) {
            var assingMekiCreditPaymentMethod1 = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    assignMethod({
                                        variables: {
                                            params: {
                                                orderUuid: orderUuid,
                                                paymentMethodUuid: "00000000-0000-0000-0000-00000000"
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                assignPaymentMethod: {
                                                    __typename: "Order",
                                                    id: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                                    uuid: orderUuid,
                                                    paymentMethod: {
                                                        id: -1
                                                    }
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function assingMekiCreditPaymentMethod1() {
                    return _ref.apply(this, arguments);
                };
            }();
            void assingMekiCreditPaymentMethod1();
            void track("add payment succeed", {
                payment_method_type: "MEKI_CREDIT",
                userId: user === null || user === void 0 ? void 0 : user.id
            });
        }
    }, [
        mekiCreditsChecked,
        assignMethod,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        orderUuid,
        track,
        payAmount,
        user === null || user === void 0 ? void 0 : user.id, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* ContentContainer */.E, {
            background: "#F5F5F5",
            bottomNavigation: main/* isMobile */.tq,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader/* Header */.h, {
                    title: "M\xe9todo de pago",
                    backIcon: true,
                    backFunction: function() {
                        void modalRouter.push((0,utils/* getRoute */.Bv)("checkoutDetail"));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* ModalContent */.h, {
                    isSafari: environment/* isSafari */.G6,
                    desktopHeight: calculateHeight("desktop", showNextButton, userHasInsurances),
                    mobileHeight: calculateHeight("mobile", showNextButton, userHasInsurances),
                    children: contentLoading || redirecting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentSwitchContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PaymentSwitch */.HT, {
                                        label: "Enviar email",
                                        loading: contentLoading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PaymentSwitch */.HT, {
                                        label: "Incluir costo de despacho",
                                        loading: contentLoading
                                    })
                                ]
                            }),
                            (currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MekiCredits */.Pn, {
                                        loading: contentLoading
                                    }),
                                    (insurancesData === null || insurancesData === void 0 ? void 0 : (ref4 = insurancesData.getUserInsurances) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoDiv, {
                                        hidden: contentLoading || !mekiCreditsChecked,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIconButton, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                                children: "Los Cr\xe9ditos Meki no pueden utilizarse junto a un seguro."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (insurancesData === null || insurancesData === void 0 ? void 0 : (ref5 = insurancesData.getUserInsurances) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* InsuranceOptions */.VL, {
                                loadingInsurances: loadingInsurances,
                                loadingCircle: loadingGetInsuranceQuote,
                                loadInsuranceQuote: loadInsuranceQuote,
                                mekiCreditsChecked: !showInsuranceOptions,
                                userInsurances: insurancesData === null || insurancesData === void 0 ? void 0 : insurancesData.getUserInsurances,
                                quoteError: insuranceQuoteError
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoDiv, {
                                hidden: !insuranceId || insuranceId && quoteLoading || !userHasInsurances || !!insuranceQuoteError,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIconButton, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
                                    }),
                                    productsWithInsurance == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                        children: "Tu seguro no cubre ninguno de los productos agregados al carro."
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoTypography, {
                                        children: [
                                            orderDetailsAmount == productsWithInsurance ? "Todos tus productos tienen cobertura." : productsWithInsurance == 1 ? "\n                      ".concat(productsWithInsurance, " de tus productos tiene cobertura.") : "".concat(productsWithInsurance, " de tus productos tienen cobertura."),
                                            " ",
                                            payAmount != 0 ? "Selecciona un m\xe9todo de pago para ver m\xe1s detalles." : ""
                                        ]
                                    })
                                ]
                            }),
                            (quoteLoading || payAmount > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PaymentsOptions */.Cn, {
                                loading: contentLoading,
                                quoteLoading: quoteLoading,
                                handleNext: handleNext
                            })
                        ]
                    })
                }),
                showNextButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButton/* ModalButton */.m, {
                    handleNext: function() {
                        return handleNext();
                    },
                    text: "Siguiente",
                    children: !isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter/* PaymentFooter */.k, {
                        payAmount: payAmount,
                        userHasInsurances: userHasInsurances,
                        quoteLoading: quoteLoading,
                        showNextButton: showNextButton
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: !isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentFooter/* PaymentFooter */.k, {
                        payAmount: payAmount,
                        userHasInsurances: userHasInsurances,
                        quoteLoading: quoteLoading,
                        showNextButton: showNextButton
                    })
                })
            ]
        })
    });
}


/***/ })

}]);